'use es6';

import { Fragment, useMemo, useState } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UISearchInput from 'UIComponents/input/UISearchInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileRadioGroup = ({
  defaultValue,
  onChange,
  options,
  searchEnabled,
  searchPlaceholder,
  translateOption,
  value
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const renderedInputs = useMemo(() => {
    return options.filter(option => {
      if (searchTerm) {
        const searchRegex = new RegExp(searchTerm, 'i');
        return searchRegex.test(translateOption(option));
      }
      return true;
    }).map(option => {
      return /*#__PURE__*/_jsx(UIRadioInput, {
        checked: option === value,
        className: "m-bottom-2",
        onChange: ({
          target: {
            checked
          }
        }) => {
          if (checked) {
            onChange(option);
          }
        },
        children: option ? translateOption(option) : defaultValue
      }, option);
    });
  }, [defaultValue, onChange, options, searchTerm, translateOption, value]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [searchEnabled && /*#__PURE__*/_jsx(UIFormControl, {
      "aria-label": "radio-search",
      className: "m-bottom-2",
      children: /*#__PURE__*/_jsx(UISearchInput, {
        onChange: ({
          target: {
            value: searchValue
          }
        }) => {
          if (searchValue.trim()) {
            setSearchTerm(searchValue);
          } else {
            setSearchTerm('');
          }
        },
        placeholder: searchPlaceholder
      })
    }), renderedInputs]
  });
};
MobileRadioGroup.propTypes = {
  defaultValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.oneOfType([PropTypes.instanceOf(Immutable.Set), PropTypes.array]).isRequired,
  searchEnabled: PropTypes.bool,
  searchPlaceholder: PropTypes.string,
  translateOption: PropTypes.func.isRequired,
  value: PropTypes.string
};
export default MobileRadioGroup;